/** 全站页脚产品分组（与侧栏顺序无关） */
export const FOOTER_PRODUCT_GROUPS = [
  {
    titleKey: 'footerGroupTalkingAvatars',
    items: [
      { labelKey: 'aiTalkingPhoto', to: '/talking-photo-ai' },
      { labelKey: 'aiTalkingAvatar', to: '/talking-avatar' },
      { labelKey: 'aiNewsAnchor', to: '/ai-news-anchor' },
      { labelKey: 'avatarDialogue', to: '/avatar-dialogue' },
      { labelKey: 'aiBabyPodcast', to: '/ai-baby-podcast' },
      { labelKey: 'aiDubbing', to: '/ai-dubbing' },
    ],
  },
  {
    titleKey: 'footerGroupAudioSinging',
    items: [
      { labelKey: 'lipsync', to: '/' },
      { labelKey: 'aiSingingPhoto', to: '/ai-singing-photo' },
      { labelKey: 'babySinging', to: '/baby-singing' },
      { labelKey: 'audioCleaner', to: '/audio-cleaner' },
      { labelKey: 'audioEnhancer', to: '/audio-enhancer' },
    ],
  },
  {
    titleKey: 'footerGroupCreativeCartoon',
    items: [
      { labelKey: 'aiTalkingAnimals', to: '/talking-animals' },
      { labelKey: 'aiTalkingCartoon', to: '/talking-cartoon' },
      { labelKey: 'singCartoon', to: '/cartoon-singing' },
      { labelKey: 'aiBabyTalking', to: '/baby-talking' },
      { labelKey: 'aiInfluencer', to: '/ai-influencer-generator' },
      { labelKey: 'aiAvatarGenerator', to: '/ai-avatar-generator' },
    ],
  },
]
